import React from 'react';
import EditIcon from 'assets/svgs/common/check-black.svg';
import ActiveEditIcon from 'assets/svgs/common/check-white.svg';

import BootstrapSelect from 'components/CustomSelect/BootstrapSelect';
import messages from '../../messages';

const Manager = ({selected, setSelected, options}) => (
  <BootstrapSelect
    selected={selected}
    options={options}
    icon={EditIcon}
    iconActive={ActiveEditIcon}
    onChange={(e) => {
      setSelected(e);
    }}
    onClear={(e) => {
      setSelected(null);
    }}
    enableClear
    label={messages.manager}
    displaySelected
    displaySelectedValue={(e) => `${e.firstName} ${e.lastName}`}
    isUser
    className="editor-btn pr-0"
  />
);

export default Manager;
